(function () {
  'use strict';

  if (window.__NXEDC_MINICART_READY__) return;
  window.__NXEDC_MINICART_READY__ = true;

  var SECTION_ID = 'nxedc-cart-drawer';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function cartRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  function getMinicart() {
    return document.querySelector('[data-nxedc-minicart]');
  }

  function getContentRoot() {
    return document.getElementById('shopify-section-nxedc-cart-drawer');
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.nxedc-header__cart, .nxedc-mobile-nav__cart').forEach(function (cartBtn) {
      var badge = cartBtn.querySelector('.nxedc-header__count, .nxedc-mobile-nav__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = cartBtn.classList.contains('nxedc-mobile-nav__cart')
            ? 'nxedc-mobile-nav__badge'
            : 'nxedc-header__count';
          cartBtn.appendChild(badge);
        }
        badge.textContent = String(count);
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function openMinicart() {
    var minicart = getMinicart();
    if (!minicart) return;
    minicart.classList.add('is-open');
    minicart.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('open-minicart');
    document.body.classList.add('open-minicart');
    var closeBtn = minicart.querySelector('.nxedc-minicart__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeMinicart() {
    var minicart = getMinicart();
    if (!minicart) return;
    minicart.classList.remove('is-open');
    minicart.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('open-minicart');
    document.body.classList.remove('open-minicart');
  }

  function setLoading(loading) {
    var minicart = getMinicart();
    if (minicart) minicart.classList.toggle('is-loading', loading);
  }

  function bindMinicartEvents(root) {
    if (!root) return;

    root.querySelectorAll('[data-nxedc-minicart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMinicart);
    });

    root.querySelectorAll('[data-nxedc-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-nxedc-cart-remove');
        if (key) changeLine(key, 0);
      });
    });

    root.querySelectorAll('[data-nxedc-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-nxedc-minicart-qty]');
        var input = wrap && wrap.querySelector('[data-nxedc-cart-qty-input]');
        if (!input) return;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        input.value = String(next);
        queueQtyUpdate(input);
      });
    });

    root.querySelectorAll('[data-nxedc-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-nxedc-minicart-qty]');
        var input = wrap && wrap.querySelector('[data-nxedc-cart-qty-input]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 0) + 1;
        input.value = String(next);
        queueQtyUpdate(input);
      });
    });

    root.querySelectorAll('[data-nxedc-cart-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        queueQtyUpdate(input);
      });
    });

    root.querySelectorAll('[data-nxedc-minicart-checkout]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        handleMobileCheckout(event, btn);
      });
    });

    var checkoutForm = root.querySelector('[data-nxedc-minicart-checkout-form]');
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', function (event) {
        var btn = checkoutForm.querySelector('[data-nxedc-minicart-checkout]');
        if (btn) handleMobileCheckout(event, btn);
      });
    }
  }

  var qtyTimer = null;
  var pendingQtyInput = null;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function navigateCheckout() {
    var checkoutUrl = cartRoot() + 'checkout';
    setLoading(false);
    if (window.location.href.indexOf(checkoutUrl) !== -1) return;
    window.location.assign(checkoutUrl);
  }

  function flushPendingQtyUpdate() {
    if (!pendingQtyInput) return Promise.resolve();
    var input = pendingQtyInput;
    pendingQtyInput = null;
    clearTimeout(qtyTimer);
    qtyTimer = null;
    var key = input.getAttribute('data-line-key');
    var qty = parseInt(input.value, 10);
    if (!key || isNaN(qty)) return Promise.resolve();
    return changeLine(key, qty, { skipRefresh: true });
  }

  function handleMobileCheckout(event, btn) {
    if (!isMobileViewport()) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    if (btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    flushPendingQtyUpdate()
      .catch(function () {})
      .then(navigateCheckout);
  }

  function queueQtyUpdate(input) {
    pendingQtyInput = input;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      qtyTimer = null;
      pendingQtyInput = null;
      var key = input.getAttribute('data-line-key');
      var qty = parseInt(input.value, 10);
      if (!key || isNaN(qty)) return;
      changeLine(key, qty);
    }, 350);
  }

  function changeLine(key, quantity, options) {
    options = options || {};
    if (!options.skipRefresh) setLoading(true);
    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        if (options.skipRefresh) return cart;
        return refreshMinicart();
      })
      .catch(function () {
        if (!options.skipRefresh) setLoading(false);
      });
  }

  function previewQuery() {
    var src = new URLSearchParams(window.location.search);
    var dest = new URLSearchParams();
    ['preview_theme_id', 'pb', 'key', 'preview'].forEach(function (key) {
      if (src.has(key)) dest.set(key, src.get(key));
    });
    if (
      !dest.has('preview_theme_id') &&
      window.Shopify &&
      Shopify.theme &&
      Shopify.theme.id &&
      Shopify.theme.role &&
      Shopify.theme.role !== 'main'
    ) {
      dest.set('preview_theme_id', String(Shopify.theme.id));
    }
    var query = dest.toString();
    return query ? '&' + query : '';
  }

  function applySectionHtml(html) {
    var root = getContentRoot();
    if (!root || !html) return false;
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var next = temp.querySelector('#shopify-section-' + SECTION_ID) || temp.firstElementChild;
    if (!next || !root.parentNode) return false;
    next.setAttribute('data-nxedc-minicart-content', '');
    root.replaceWith(next);
    bindMinicartEvents(next);
    return true;
  }

  function getEngravingInput(form) {
    if (!form) return null;
    var input = form.querySelector('[data-nxedc-engraving]');
    if (input) return input;
    if (form.id) {
      return document.querySelector('[data-nxedc-engraving][form="' + form.id + '"]');
    }
    return null;
  }

  function setEngravingError(form, show) {
    var input = getEngravingInput(form);
    var error = (form && form.querySelector('[data-nxedc-engraving-error]')) ||
      (input && input.parentElement && input.parentElement.querySelector('[data-nxedc-engraving-error]'));
    if (input) input.classList.toggle('is-invalid', show);
    if (error) error.hidden = !show;
  }

  function validateEngraving(form) {
    var input = getEngravingInput(form);
    if (!input || input.disabled || input.closest('[hidden], [data-nxedc-engraving-wrap][hidden]')) return true;
    var value = String(input.value || '').trim();
    if (value) {
      input.value = value;
      input.setCustomValidity('');
      setEngravingError(form, false);
      return true;
    }
    input.value = '';
    input.setCustomValidity('Please enter your engraving text, or type NO if none');
    setEngravingError(form, true);
    if (typeof input.reportValidity === 'function') input.reportValidity();
    input.focus();
    return false;
  }

  function collectLineProperties(form) {
    var properties = {};
    var fields = [];
    if (form) {
      form.querySelectorAll('[name^="properties["]').forEach(function (el) {
        fields.push(el);
      });
      if (form.id) {
        document.querySelectorAll('[form="' + form.id + '"][name^="properties["]').forEach(function (el) {
          if (fields.indexOf(el) === -1) fields.push(el);
        });
      }
    }
    fields.forEach(function (input) {
      if (!input || input.disabled) return;
      var match = String(input.name || '').match(/^properties\[(.*)\]$/);
      if (!match) return;
      var key = match[1];
      if (!key || key.charAt(0) === '_') return;
      var value = String(input.value || '').trim();
      if (value) properties[key] = value;
    });
    return properties;
  }

  function paintLineProperties(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item) {
      var row = document.querySelector('[data-nxedc-cart-line="' + item.key + '"]');
      if (!row) return;
      var info = row.querySelector('.nxedc-minicart__item-info');
      if (!info) return;
      var props = item.properties || {};
      Object.keys(props).forEach(function (key) {
        if (!key || key.charAt(0) === '_') return;
        var value = props[key];
        if (value == null || String(value).trim() === '') return;
        if (row.querySelector('[data-nxedc-prop="' + key.replace(/"/g, '') + '"]')) return;
        var already = Array.prototype.some.call(row.querySelectorAll('.nxedc-minicart__item-variant'), function (el) {
          return el.textContent.indexOf(key + ':') === 0;
        });
        if (already) return;
        var line = document.createElement('p');
        line.className = 'nxedc-minicart__item-variant';
        line.setAttribute('data-nxedc-prop', key);
        line.textContent = key + ': ' + value;
        var promo = info.querySelector('.nxedc-minicart__item-promo');
        var prices = info.querySelector('.nxedc-minicart__item-prices');
        if (promo) info.insertBefore(line, promo);
        else if (prices) info.insertBefore(line, prices);
        else info.appendChild(line);
      });
    });
  }

  function refreshMinicart() {
    var root = getContentRoot();
    if (!root) return Promise.resolve();

    setLoading(true);
    var sectionUrl = cartRoot() + '?sections=' + SECTION_ID + previewQuery();

    return fetch(sectionUrl, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Section fetch failed');
        return res.json();
      })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) throw new Error('Missing section HTML');
        applySectionHtml(html);
        return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) {
        if (res && res.ok) return res.json();
      })
      .then(function (cart) {
        if (cart) {
          updateHeaderCount(cart.item_count);
          paintLineProperties(cart);
        }
      })
      .catch(function () {
        /* Section API unavailable — keep existing markup */
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function cartAddPayload(form) {
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput && idInput.value;
    var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    return {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: collectLineProperties(form)
        }
      ],
      sections: SECTION_ID,
      sections_url: window.location.pathname + window.location.search
    };
  }

  function postCartAdd(payload) {
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function buyNowFromForm(form, btn) {
    if (!form || (btn && btn.disabled)) return Promise.resolve();
    if (!validateEngraving(form)) return Promise.resolve();

    if (btn) btn.disabled = true;
    setLoading(true);

    return postCartAdd(cartAddPayload(form))
      .then(function () {
        window.location.href = cartRoot() + 'checkout';
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not start checkout';
        alert(msg);
      })
      .finally(function () {
        if (btn) btn.disabled = false;
        setLoading(false);
      });
  }

  function addToCartFromForm(form) {
    if (!validateEngraving(form)) return Promise.resolve();

    var addBtn = form.querySelector('[name="add"]');
    if (addBtn) addBtn.disabled = true;
    setLoading(true);

    return postCartAdd(cartAddPayload(form))
      .then(function (data) {
        var applied = data && data.sections && data.sections[SECTION_ID]
          ? applySectionHtml(data.sections[SECTION_ID])
          : false;
        var next = applied ? Promise.resolve() : refreshMinicart();
        return next.then(function () {
          return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
        });
      })
      .then(function (res) {
        if (res && res.ok) return res.json();
      })
      .then(function (cart) {
        if (cart) {
          updateHeaderCount(cart.item_count);
          paintLineProperties(cart);
        }
        openMinicart();
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart';
        alert(msg);
      })
      .finally(function () {
        if (addBtn) addBtn.disabled = false;
        setLoading(false);
      });
  }

  function shouldAjaxCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.hasAttribute('data-nxedc-ajax-cart')) return true;
    if (form.id === 'nxedc-product-form') return true;
    if (!form.closest('.nxedc-clone')) return false;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') !== -1) return true;
    return Boolean(form.querySelector('[name="add"]'));
  }

  function handleCartFormSubmit(e) {
    var form = e.target;
    if (!shouldAjaxCartForm(form)) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    addToCartFromForm(form);
  }

  function initMinicartShell() {
    var minicart = getMinicart();
    if (!minicart) return;

    bindMinicartEvents(minicart);

    minicart.querySelectorAll('[data-nxedc-minicart-close]').forEach(function (el) {
      el.addEventListener('click', closeMinicart);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && minicart.classList.contains('is-open')) {
        closeMinicart();
      }
    });
  }

  function initCartTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-nxedc-minicart-open], .nxedc-header__cart, .nxedc-mobile-nav__cart');
      if (!trigger) return;
      e.preventDefault();
      refreshMinicart().then(openMinicart);
    });
  }

  function initProductForms() {
    document.addEventListener('submit', handleCartFormSubmit, true);

    document.addEventListener('click', function (e) {
      var buyNowBtn = e.target.closest('[data-nxedc-buy-now]');
      if (!buyNowBtn) return;
      var form = buyNowBtn.closest('form');
      if (!form || !shouldAjaxCartForm(form)) return;
      e.preventDefault();
      e.stopPropagation();
      buyNowFromForm(form, buyNowBtn);
    });

    document.addEventListener('click', function (e) {
      var payHost = e.target.closest(
        '.shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout, shopify-google-pay-button, shopify-paypal-button, shopify-apple-pay-button'
      );
      if (!payHost) return;
      var form = payHost.closest('form') || document.getElementById('nxedc-product-form');
      if (!form || !shouldAjaxCartForm(form)) return;
      if (!validateEngraving(form)) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('input', function (e) {
      if (!e.target || !e.target.matches('[data-nxedc-engraving]')) return;
      var form = e.target.form || e.target.closest('form') || document.getElementById(e.target.getAttribute('form') || '');
      if (String(e.target.value || '').trim()) {
        e.target.setCustomValidity('');
        setEngravingError(form, false);
      }
    });

    document.querySelectorAll('[data-nxedc-ajax-cart], #nxedc-product-form').forEach(function (form) {
      form.setAttribute('data-nxedc-ajax-cart', '');
    });
  }

  ready(function () {
    initMinicartShell();
    initCartTriggers();
    initProductForms();
    initStandardActionsBridge();
  });

  function initStandardActionsBridge() {
    var actions = window.Shopify && window.Shopify.actions;
    if (!actions || !actions.openCart || actions.openCart.__nxedcBound) return;
    actions.openCart.__nxedcBound = true;

    actions.openCart.configure({
      handler: function () {
        return refreshMinicart().then(openMinicart);
      }
    });
  }

  window.NXEDCMinicart = {
    open: openMinicart,
    close: closeMinicart,
    refresh: refreshMinicart
  };
})();
